import React, { useEffect, useState } from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';

import TouchableElement from '@components/common/touchableElement';
import EditableLine from '@components/common/editableLine';

import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';

export default ({ C, updateData, setData, data, validateMachineOnboardingEndpoint, startMachineOnboardingSession, setMode, goBack, MODES }) => {
  const submitDisabled = !data.endpoint || data.loading;
  const [isError, setIsError] = useState(false);

  const submit = async () => {
    if (submitDisabled) {
      return;
    }
    const newData = { ...data };
    newData.loading = true;
    setData(newData);
    const machineOnboardingSessionId = await startMachineOnboardingSession(data);
    if (machineOnboardingSessionId) {
      newData.machineOnboardingSessionId = machineOnboardingSessionId;
      setData(newData);
      const resp = (await validateMachineOnboardingEndpoint({ machineOnboardingSessionId })) || {};

      const isSuccess = resp?.endpointReachableResult?.isReachable;

      newData.loading = false;
      setData(newData);
      if (isSuccess) {
        return setMode(MODES.MACHINE_CONNECTION_METHOD);
      }
    }
    setIsError(true);
  };

  return (
    <View>
      <View>
        <View
          style={{
            width: '100%',
            zIndex: 1000,
            height: scale(58),
          }}
        >
          <View style={{ position: 'absolute', zIndex: 1000, left: 0 }}>
            <TouchableElement
              onPress={() => {
                goBack();
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15), flexDirection: 'row' }]}>
                  <View style={{ marginTop: scale(2) }}>
                    <Svg icon="chevronLeft" width={scale(11)} height={scale(17)} color="Link / Light / Primary" />
                  </View>
                  <Text style={[{ color: C(pressHoverColor('System/Light/Blue')), marginLeft: scale(7) }, font.Body]}>{i18n.t('Back')}</Text>
                </View>
              )}
            </TouchableElement>
          </View>
          {!isError && (
            <View style={{ position: 'absolute', zIndex: 1000, right: 0 }}>
              <TouchableElement onPress={submit}>
                {({ boxStyle, pressHoverColor }) => (
                  <View style={[boxStyle, { padding: scale(15) }]}>
                    <Text style={[{ color: C(pressHoverColor(submitDisabled ? 'Label/Light/Quinary' : 'Link/Light/Primary')) }, font.Headline]}>
                      {i18n.t('Connect')}
                    </Text>
                  </View>
                )}
              </TouchableElement>
            </View>
          )}
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>
            {i18n.t(isError ? '' : data.machineId ? 'Edit Machine' : 'Add Machine')}
          </Text>
        </View>
      </View>
      {isError ? (
        <View style={{ marginTop: scale(20), alignItems: 'center' }}>
          <Svg icon={'errorBig'} width={scale(44)} height={scale(40)} color={C('Label/Light/Error')} />
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center', marginTop: scale(16) }, font.Headline]}>
            {i18n.t('Machine Connection Failed')}
          </Text>
          <Text style={[{ color: C('Label/Light/Tertiary'), width: '100%', textAlign: 'center', marginTop: scale(48) }, font.Body]}>
            {i18n.t('Cannot ping to')} {data.endpoint}
          </Text>

          <TouchableElement
            onPress={() => {
              setMode(MODES.MACHINE_CONNECTION_METHOD);
            }}
          >
            {({ boxStyle, pressHoverColor }) => (
              <View style={[boxStyle, { padding: scale(15), marginTop: scale(48) }]}>
                <Text style={[{ color: C(pressHoverColor('Link/Light/Primary')) }, font.Headline]}>{i18n.t('Continue Anyway')}</Text>
              </View>
            )}
          </TouchableElement>
        </View>
      ) : (
        <View style={{ paddingHorizontal: isPhone ? 0 : scale(15) }}>
          <View style={{ marginTop: scale(20) }}>
            <EditableLine
              {...{
                item: {
                  value: data.endpoint,
                  key: 'endpoint',
                  placeholder: 'Host name or IP address',
                  noArrow: true,
                  isLable: false,
                  submit: submit,
                  onChange: (v) => updateData('endpoint', v),
                },
                editable: !data.loading,
                bg: modalFieldBg,
                index: 0,
                array: [{}],
                C,
                bottomBorderBox: isPhone,
                topBorderBox: isPhone,
                topBorder: false,
                roundTop: isPhone ? false : true,
                roundBottom: isPhone ? false : true,
              }}
            />
          </View>
          <View style={{ marginTop: scale(6), paddingHorizontal: scale(15), marginBottom: scale(15) }}>
            {data.loading ? (
              <Text style={[{ color: C('Label/Light/Primary') }, font.Body]}>{i18n.t('Pinging...')}</Text>
            ) : (
              <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>
                {i18n.t('Enter the local host name or IP address of the machine')}
              </Text>
            )}
          </View>
        </View>
      )}
    </View>
  );
};
